import React from "react";
import LoginPage from "./LoginPage/LoginPage.js";
import { useContext } from "react";
import { Navigate } from "react-router-dom";
// import { Context } from "../../utils/context.js";
import { Context } from "../../../utils/context.js";

const Login = () => {
  const { signin } = useContext(Context);

  // Redirect with <Navigate> instead of calling navigate() while rendering.
  if (signin) {
    return <Navigate to="/dashboard" replace />;
  }
  return <LoginPage />;


};

export default Login;
